import { createAction, props } from '@ngrx/store';
import { AuthTokens } from '../../models/auth-tokens.model';
import { User } from '../../models/user.model';

export const initAuth = createAction('[Auth] Init Auth');

export const login = createAction('[Auth] Login', props<{ email: string; password: string }>());

export const loginWithGmail = createAction('[Auth] Login With Gmail', props<{ idToken: string }>());
export const loginWithFacebook = createAction(
  '[Auth] Login With Facebook',
  props<{ accessToken: string }>()
);

export const loginSuccess = createAction('[Auth] Login Success', props<AuthTokens>());
export const refreshSuccess = createAction('[Auth] Refresh Success', props<AuthTokens>());

export const loginFailure = createAction('[Auth] Login Failure', props<{ error: any }>());

export const loadUser = createAction('[Auth] Load User', props<{ userId: number }>());
export const loadUserSuccess = createAction('[Auth] Load User Success', props<{ user: User }>());
export const loadUserFailure = createAction('[Auth] Load User Failure', props<{ error: any }>());

export const logout = createAction('[Auth] Logout');
export const clearAuthUser = createAction('[Auth] clear User');

export const updateAuthUserLanguage = createAction(
  '[Auth] Update Auth User Language',
  props<{
    language: 'ar' | 'en';
  }>()
);

export const clearSessionState = createAction('[Auth] Clear Session State');

export const deleteMyAccount = createAction('[Auth] Delete My Account');

export const deleteMyAccountSuccess = createAction('[Auth] Delete My Account Success');

export const deleteMyAccountFailure = createAction(
  '[Auth] Delete My Account Failure',
  props<{ error: unknown }>()
);
